module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Americans-The-S6.3c50971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Americans-The-S6.jpg
// module id = raZZ
// module chunks = 0